import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    fileName = '',
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.user.uploadCurrentAvatar, {
        fileName,
    }, options);
    if (error) return { error, status };
    return content || {};
};

